import {
  List,
  TextField,
  Datagrid,
  useCreate,
  useDelete,
  SaveButton,
  SimpleForm,
  Toolbar,
  useRefresh,
  useNotify,
  NumberInput,
  DateInput,
  DateField,
  NumberField,
  Button,
  useRecordContext,
} from 'react-admin'
import Typography from '@mui/material/Typography'
import { useParams } from 'react-router-dom'
import { useFormContext } from 'react-hook-form'
import Box from '@mui/material/Box'
import DeleteIcon from '@mui/icons-material/Delete'

import { validateRequired } from '../../utils/validate'

const AddContractToolbar = () => {
  const [create] = useCreate()
  const refresh = useRefresh()
  const notify = useNotify()

  const { id } = useParams()
  const { getValues, reset } = useFormContext()

  const onSubmit = async e => {
    e.preventDefault()

    const { amount, startDate, endDate } = getValues()
    const organizationId = parseInt(id)

    create(
      'b2b-organization-contracts',
      {
        data: {
          organizationId,
          amount,
          startDate,
          endDate,
        },
      },
      {
        onSuccess: () => {
          refresh()
          reset()
          notify('Contract created successfully')
        },
        onError: error => {
          notify(`${error.message}`, { type: 'error' })
        },
      },
    )
  }

  return (
    <Toolbar>
      <SaveButton type="button" onClick={onSubmit} label="Thêm hợp đồng" />
    </Toolbar>
  )
}

const AddContractAside = () => {
  return (
    <Box sx={{ margin: '0.5rem', width: 400 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Thêm hợp đồng mới
      </Typography>
      <SimpleForm toolbar={<AddContractToolbar />}>
        <NumberInput
          source="amount"
          label="Giá trị hợp đồng"
          fullWidth
          validate={[validateRequired('Giá trị hợp đồng')]}
        />
        <DateInput
          source="startDate"
          label="Ngày bắt đầu"
          fullWidth
          validate={[validateRequired('Ngày bắt đầu')]}
        />
        <DateInput
          source="endDate"
          label="Ngày kết thúc"
          fullWidth
          validate={[validateRequired('Ngày kết thúc')]}
        />
      </SimpleForm>
    </Box>
  )
}

const DeleteContractButton = () => {
  const record = useRecordContext()
  const [deleteOne] = useDelete()
  const refresh = useRefresh()
  const notify = useNotify()

  const handleDelete = () => {
    if (window.confirm('Bạn có chắc chắn muốn xóa hợp đồng này?')) {
      deleteOne(
        'b2b-organization-contracts',
        { id: record.id },
        {
          onSuccess: () => {
            refresh()
            notify('Contract deleted successfully')
          },
          onError: error => {
            notify(`${error.message}`, { type: 'error' })
          },
        },
      )
    }
  }

  return (
    <Button label="Xóa" onClick={handleDelete} color="error">
      <DeleteIcon />
    </Button>
  )
}

const ContractTab = ({ organizationId }) => {
  return (
    <>
      {!organizationId && (
        <Typography variant="body1">
          Bạn phải lưu "Thông tin công ty" trước khi cập nhật danh sách hợp
          đồng!
        </Typography>
      )}
      {organizationId && (
        <List
          sx={{ width: '100%' }}
          disableSyncWithLocation
          actions={null}
          resource="b2b-organization-contracts"
          basePath="/b2b-organization-contracts"
          aside={<AddContractAside />}
          filter={{
            organizationId: organizationId,
          }}>
          <Datagrid rowClick={false} bulkActionButtons={false}>
            <TextField source="id" label="ID" />
            <NumberField
              source="amount"
              label="Giá trị hợp đồng"
              options={{ style: 'currency', currency: 'VND' }}
            />
            <DateField source="startDate" label="Ngày bắt đầu" />
            <DateField source="endDate" label="Ngày kết thúc" />
            <DeleteContractButton label="Actions" />
          </Datagrid>
        </List>
      )}
    </>
  )
}

export default ContractTab
